import eventHub from './index'

/* deprecated */
// Trigger rate tables events on HTML click
let html = document.getElementsByTagName('html')
html[0].onclick = function() {
  eventHub.$emit('tooltip::close')
  eventHub.$emit('dropDown::close')
  eventHub.$emit('termsSelector::close')
  eventHub.$emit('adDisclosure::close')
}
window.addEventListener('scroll', function() {
  eventHub.$emit('backToTop::scroll')
})
window.addEventListener('resize', function() {
  eventHub.$emit('backToTop::resize')
})
